<template>
  <div>
    <Row>
      <!-- 适配手机版 -->
      <Col :xs="{ span: 24 }" :lg="{ span: 0 }">
        <div style="color:#000">当前位置：首页 > 网站地图 </div>
        <div style="border: 1px solid #a4a4a4;background: #f8f8f9;color: #4b4b4b;padding: 10px 30px 20px 30px;">
          <div v-for="item in list" class="dituCon">
            <div class="dituTitle">
              {{item.YijiLanmu}}：
            </div>
            <div>
              <a v-if="item.YijiLanmu=='首页' " @click="goHome" style="color:#00f;">首页</a>
              <a v-else @click="goLanmu(index,li.ErjiId)" v-for="(li,index) in item.ErJiLanMu" style="color:#00f;display: inline-flex;margin-right:50px;font-size: 15px;margin-bottom:10px;">{{li.ErjiLanmu}}</a>
            </div>
          </div>
          <div class="dituCon">
            <div class="dituTitle">
              快速通道：
            </div>
            <div>
              <a @click="goKuaisu(item)" v-for="item in kuaisuList" style="color:#00f;display: inline-flex;margin-right:50px;font-size: 15px;margin-bottom:10px;">{{item.name}}</a>
            </div>
          </div>
        </div>
      </Col>
      <!-- 电脑端 -->
      <Col :xs="{ span: 0 }" :lg="{ span: 24 }">
      <Col :xs="{ span: 24 }" :lg="{ span: 18 ,offset:3}" style="margin-bottom:20px">
        <div>当前位置：首页 > 网站地图 </div>
        <div style="border: 1px solid #a4a4a4;background: #f8f8f9;color: #4b4b4b;padding: 50px 94px 20px 94px;margin:10px 0 30px 0">
          <h1 style="font-size: 20px;text-align: center;">网站地图</h1>
          <div v-for="item in list" class="dituCon">
            <div class="dituTitle">
              {{item.YijiLanmu}}：
            </div>
            <div>
              <a v-if="item.YijiLanmu=='首页' " @click="goHome" style="color:#00f;">首页</a>
              <a v-else @click="goLanmu(index,li.ErjiId)" v-for="(li,index) in item.ErJiLanMu" style="color:#00f;display: inline-flex;margin-right:50px;font-size: 15px;margin-bottom:10px;">{{li.ErjiLanmu}}</a>
            </div>
          </div>
          <div class="dituCon">
            <div class="dituTitle">
              快速通道：
            </div>
            <div>
              <a @click="goKuaisu(item)" v-for="item in kuaisuList" style="color:#00f;display: inline-flex;margin-right:50px;font-size: 15px;margin-bottom:10px;">{{item.name}}</a>
            </div>
          </div>
        </div>
      </Col>  
      </Col>
    </Row>
    <!-- 发布中，请稍等 -->
    <Spin size="large" fix v-if="spinShow">
        <div class="loader">
            <Icon type="ios-loading" size=80 class="demo-spin-icon-load"></Icon>
            <div>加载中</div>
        </div>
    </Spin> 
  </div>
</template>

<script>
import { xxShouYeYiJi,xxFastChannel} from '@/api/index'
export default {
  name: 'ditu',
  data(){
    return{
      organ_id:'',
      spinShow:false,
      list:[],
      kuaisuList:[],
    }
  },
  methods:{
    //Mark:返回首页
    goHome(){
      this.$router.push({name:'Home'})
    },
    //Mark:跳转分类
    goLanmu(ind,id){
      this.$router.push({name:'menulist',query:{id:id,index:ind}});
    },
    //Mark:跳转快速通道
    goKuaisu(obj){
      if(obj.type>1){//文章
          this.$router.push({name:'menulist',query:{article_id:obj.article_id,id:obj.wz_cate_id,index:-1,isShow:true}});//isShow:true文章详情 false列表
      }else{//分类
          this.$router.push({name:'menulist',query:{id:obj.ErjiId,index:-1,isShow:false}});//isShow:true文章详情 false列表
      }
    }
  },
  mounted(){
    this.organ_id=this.GLOBAL.organ_id;
    document.title ='沁阳市第一中学'
    this.spinShow=true;
    xxShouYeYiJi({organ_id:this.organ_id}).then(res=>{
      this.spinShow=false;
      if(res.data.code){
         this.list = res.data.data
      }
    })
    this.spinShow=true;
    xxFastChannel({organ_id:this.organ_id}).then(res=>{
      this.spinShow=false;
      for(let i =0;i<res.data.data.length;i++){
        this.kuaisuList.push(res.data.data[i]);
      }
    })
  },
  watch: {
    $route: {
      handler() {
      },
      deep: true,
    }
  }
}
</script>
<style lang="less">
.dituTitle{
  margin-bottom:15px;
  font-size: 17px;
  color:#00f;
}
.dituCon{
  font-weight: bold;
  margin: 20px 0 50px 0;
}
</style>
